import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import "./DashboardPage.scss";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";
import DashboardHeader from "../../components/dashboard-page/sections/DashboardHeader/DashboardHeader";
import PendingGameEntriesSection from "../../components/dashboard-page/sections/PendingGameEntriesSection/PendingGameEntriesSection";
import StreaksSection from "../../components/dashboard-page/sections/StreaksSection/StreaksSection";
import FeaturedGameSection from "../../components/dashboard-page/sections/FeaturedGameSection/FeaturedGameSection";
import GamesListSection from "../../components/dashboard-page/sections/GamesListSection/GamesListSection";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../utils/renderHeaders";
import { FilterQueryFilterEnum } from "@nestcoinco/hyper-api-gateway-api-client";
import usePopularGamesQuery from "../../react-query/queries/use-popular-games";
import useGamesQuery from "../../react-query/queries/use-games";

const MAX_GAMES = 16;

function DashboardPage() {
  const { t } = useTranslation("dashboard");
  const { isOnboarding, clearStep } = useOnboardingSteps();

  useEffect(() => {
    if (isOnboarding) clearStep();
  }, [isOnboarding, clearStep]);

  const newThisWeekQuery = useGamesQuery({
    filter: FilterQueryFilterEnum.NEW_THIS_WEEK,
    limit: MAX_GAMES,
  });

  const popularQuery = usePopularGamesQuery({ limit: MAX_GAMES });
  const trendingGames = useMemo(
    () => popularQuery.data?.records?.map(({ game }) => game) ?? [],
    [popularQuery.data]
  );

  const mostPlayedQuery = useGamesQuery({
    filter: FilterQueryFilterEnum.MOST_PLAYED_THIS_WEEK,
    limit: MAX_GAMES,
  });

  return (
    <>
      {renderHeaders({
        title: t("metadata:sigma_home_title"),
        description: t("metadata:sigma_home_description"),
        ogTitle: extractOgTitleFromMainTitle(t("metadata:sigma_home_title")),
      })}
      <main className="dashboard-page MobileOnly">
        <DashboardHeader />
        <div className="page-sections">
          <PendingGameEntriesSection />
          <FeaturedGameSection />
          <StreaksSection />
          <GamesListSection
            title={t("new_this_week")}
            games={newThisWeekQuery.data?.records ?? []}
            isLoading={newThisWeekQuery.isLoading}
            tileLabel={t("new_this_week_tile_label")}
          />
          <GamesListSection
            title={t("trending_games")}
            games={trendingGames}
            isLoading={popularQuery.isLoading}
          />
          <GamesListSection
            title={t("most_played_this_week")}
            games={mostPlayedQuery.data?.records ?? []}
            isLoading={mostPlayedQuery.isLoading}
          />
        </div>
      </main>
    </>
  );
}

export default DashboardPage;
